<template>
  <Obj :id="id" :value="event">
    <Event
      v-if="event && patch"
      ref="component"
      :event="event"
      :has-unsaved-changes="hasUnsavedChanges"
      :is-draft-event="isDraftEvent"
      :props-edited="propsEdited"
      :patch="patch"
      :embedded-mode="embeddedMode"
      @confirm="confirm"
      @discard="discard"
    />
  </Obj>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUpdated, toRefs } from "vue";
import { useRoute } from "vue-router";

import Component from "@/components/event/Event.vue";
import * as inject from "@/components/inject";
import { useEvent } from "@/components/planner/controllers/event";
import { bindAsync, releasableRef, useReleaser } from "@/ref";

import Obj from "./DefaultObject.vue";

export default defineComponent({
  components: {
    Obj,
    Event: Component,
  },
  props: {
    id: { type: String, required: true },
    embeddedMode: {
      type: Boolean,
      default: false,
    },
  },
  async setup(props) {
    const { id } = toRefs(props);
    const router = inject.router();
    const controller = inject.controller();
    const baseLogger = inject.logger();
    const simpleModal = inject.simpleModal();
    const multipleEventsModal = inject.multipleEventsModal();
    const route = useRoute();
    const {
      initializeComponentFocus,
      installRouteCallbacks,
      release,
      setOriginalValue,
      ...object
    } = useEvent(
      {
        route,
        router,
        controller,
        logger: baseLogger,
        simpleModal,
        multipleEventsModal,
      },
      { id, isEventOpenInFullScreen: true }
    );
    installRouteCallbacks();
    onMounted(initializeComponentFocus);
    onUpdated(initializeComponentFocus);
    const releaser = useReleaser();
    releaser.defer(release);
    const event = await releaser.add(
      bindAsync(id, async (id) =>
        id ? await controller.event.get(id) : releasableRef(null)
      )
    );
    setOriginalValue(event);
    return object;
  },
});
</script>
